import InfiniteScroll from 'react-infinite-scroll-component';
import isEmpty from 'lodash/isEmpty';
import { Dispatch, SetStateAction, useState } from 'react';
import HolderTransactionTabFilters from '@/modules/issuer-dashboard/components/HolderTransactionTabFilters.tsx';
import IssuerHolderTransactionTabItem from '@/modules/issuer-dashboard/components/items/IssuerHolderTransactionTabItem.tsx';
import { useTransactionsListQuery } from '@/modules/issuer-dashboard/queries/transactions.ts';
import { EmptyListState, Spinner } from 'ui';
import { GetTransactionsListV1SrTransactionsGetParams, ShareholderExtendResponse } from 'api';

export type transactionsFilters = Pick<
  GetTransactionsListV1SrTransactionsGetParams,
  | 'type'
  | 'sorted_by'
  | 'confirmation_date_from'
  | 'confirmation_date_to'
  | 'requested_at_date_from'
  | 'requested_at_date_to'
  | 'status'
  | 'shareholder_id'
  | 'register_class_id'
  | 'is_deleted'
>;

interface TransactionsTabProps {
  shareholder: ShareholderExtendResponse | null;
  isDeleted?: boolean;
  setIsDeleted?: Dispatch<SetStateAction<boolean | undefined>>;
}

const TransactionsTab = ({ shareholder, isDeleted, setIsDeleted }: TransactionsTabProps) => {
  const [filters, setFilters] = useState<transactionsFilters>({});

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useTransactionsListQuery(
    {
      page: 1,
      page_size: 15,
      shareholder_id: shareholder?.id,
      ...filters,
      is_deleted: isDeleted,
    },
    !shareholder,
    shareholder?.register_id || 0,
  );

  const transactions = (data?.pages || []).flatMap(({ data }) => data);
  return (
    <div className="space-y-4">
      <HolderTransactionTabFilters
        filters={filters}
        setFilters={setFilters}
        shareholder={shareholder}
        isDeleted={isDeleted}
        setIsDeleted={setIsDeleted}
        isFetching={isFetching}
      />
      {isLoading && (
        <div className="flex h-full w-full items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
      <EmptyListState
        title="No transactions yet"
        description="To add transaction go to operations page and click on Add transaction, create and confirm this activity which will create completed transaction"
        isLoading={isLoading}
        isSearchUsed={!isEmpty(filters)}
        itemsCount={transactions.length}
      />
      <InfiniteScroll
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        style={{ overflow: 'unset' }}
        loader={
          <div className="flex justify-center items-center h-16 w-full">
            <Spinner size="md" variant="primary" />
          </div>
        }
        className="space-y-2"
        dataLength={transactions.length}
        scrollableTarget="scrollable"
      >
        {transactions.map(transaction => (
          <IssuerHolderTransactionTabItem
            key={transaction.id}
            transaction={transaction}
            isDeleted={isDeleted}
            showArchiveButton={true}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};

export default TransactionsTab;
